import { render, staticRenderFns } from "./SalesSparkline.vue?vue&type=template&id=358470c5&scoped=true&lang=pug"
import script from "./SalesSparkline.vue?vue&type=script&lang=js"
export * from "./SalesSparkline.vue?vue&type=script&lang=js"
import style0 from "./SalesSparkline.vue?vue&type=style&index=0&id=358470c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358470c5",
  null
  
)

export default component.exports